import { computed } from 'vue';
import {
  useThemeTick,
  color,
} from 'dashboard/components-next/analytics/composables/useThemeColors';
import { QUEM_CORES } from '../atendimento/quemCores';

// Canvas não lê classe nem variável CSS: as cores saem dos tokens de gráfico do
// tema já resolvidos, e `tick` refaz tudo quando o tema vira. A de cada quem (ia,
// disparo, pessoa, espera) vem do mapa único, quemCores.js.
export function useAnalyticsChart() {
  const tick = useThemeTick();

  const palette = computed(() => ({
    tick: tick.value,
    ...Object.fromEntries(
      Object.entries(QUEM_CORES).map(([key, cor]) => [
        key,
        color(cor.chart, cor.fallback),
      ])
    ),
    muted: color('--pz-chart-muted', '#696e77'),
    grid: color('--pz-chart-border-soft', '#e0e1e6'),
  }));

  const bar = (label, data, backgroundColor) => ({
    label,
    data,
    backgroundColor,
    borderRadius: 3,
    barPercentage: 0.9,
    categoryPercentage: 0.8,
    maxBarThickness: 18,
  });

  // formatValue: como escrever o número no eixo e no tooltip. Contagem não tem
  // meio: sem `precision: 0` um dia com 1 mensagem ganha um eixo 0; 0,5; 1.
  const chartOptions = (formatValue, { integer = true } = {}) => {
    const { muted, grid } = palette.value;
    return {
      interaction: { mode: 'index', intersect: false },
      plugins: {
        legend: { display: false },
        tooltip: {
          callbacks: {
            label: item => `${item.dataset.label}: ${formatValue(item.raw)}`,
          },
        },
      },
      scales: {
        x: {
          grid: { display: false },
          ticks: {
            color: muted,
            maxRotation: 0,
            autoSkip: true,
            maxTicksLimit: 8,
          },
        },
        y: {
          beginAtZero: true,
          border: { display: false },
          grid: { color: grid },
          ticks: {
            color: muted,
            maxTicksLimit: 4,
            precision: integer ? 0 : undefined,
            callback: value => formatValue(value),
          },
        },
      },
    };
  };

  return { palette, bar, chartOptions };
}
